"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HomeLink = exports.getNavItemElements = void 0;
var React = __importStar(require("react"));
var GKResponsiveNav_models_1 = require("./GKResponsiveNav.models");
var components_1 = require("../../../components");
// eslint-disable-next-line @typescript-eslint/no-unused-vars
/**
 * Takes in an array of FlexibleNavItems and returns and array of
 * RouterNavLink, GKNavLink, and/or GKNavItem components
 *
 * @param navItems An array of NavItemType
 * @param isCollapsed If true, returns shortLabel if provided
 */
var getNavItemElements = function (navItems, isCollapsed) {
    return navItems.map(function (item, index) {
        var content = null;
        var passthruProps = {};
        if ((0, GKResponsiveNav_models_1.isTargetingRouter)(item)) {
            var to = item.to, icon = item.icon, shortLabel = item.shortLabel, label = item.label, badge = item.badge, onClick = item.onClick, pass = __rest(item, ["to", "icon", "shortLabel", "label", "badge", "onClick"]);
            passthruProps = __assign({}, pass);
            content = (React.createElement(components_1.GKRouterNavLink, { to: to, className: "cursor-pointer", onClick: onClick },
                icon && React.createElement(components_1.GKIcon, { name: icon }),
                React.createElement("span", { className: "label" }, isCollapsed && shortLabel ? shortLabel : label),
                badge && React.createElement(components_1.GKBadge, null, badge)));
        }
        else if ((0, GKResponsiveNav_models_1.isTargetingHref)(item)) {
            var href = item.href, active = item.active, icon = item.icon, shortLabel = item.shortLabel, label = item.label, badge = item.badge, target = item.target, onClick = item.onClick, pass = __rest(item, ["href", "active", "icon", "shortLabel", "label", "badge", "target", "onClick"]);
            passthruProps = __assign({}, pass);
            content = (React.createElement(components_1.GKNavLink, { href: href, active: active, className: "cursor-pointer", onClick: onClick, target: target !== null && target !== void 0 ? target : "_blank" },
                icon && React.createElement(components_1.GKIcon, { name: icon }),
                React.createElement("span", { className: "label" }, isCollapsed && shortLabel ? shortLabel : label),
                badge && React.createElement(components_1.GKBadge, null, badge)));
        }
        else {
            content = item;
        }
        return (React.createElement(components_1.GKNavItem, __assign({ key: "navItem-" + index }, passthruProps), content));
    });
};
exports.getNavItemElements = getNavItemElements;
var HomeLink = function (_a) {
    var incomingClasses = _a.className, isInNavbar = _a.isInNavbar, home = _a.home, children = _a.children;
    var className = (incomingClasses || "") +
        (isInNavbar ? " navbar-brand" : " d-inline-block w-100 text-center");
    if ((0, GKResponsiveNav_models_1.isTargetingRouter)(home)) {
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        var Component = require("react-router-dom").NavLink;
        return (React.createElement(Component, { className: className, to: home.to || "" }, children));
    }
    else {
        return (React.createElement("a", { className: className, href: (home && home.href) || "/" }, children));
    }
};
exports.HomeLink = HomeLink;
